var ContactViewModel = function () {
    var self = this;

    self.contacts = ko.observableArray([]);
    self.isBusy = ko.observable(false);

    self.getContacts = function () {
        self.isBusy(true);

        $.ajax({
            type: 'POST',
            url: '/Contact/GetContactInfo',
            contentType: 'application/json',
            data: {},
            success: function (data) {
                //possibly refactor to display the confirmation results anyway for some of the error types such as reschedule or not ready
                //^so they don't call to reschedule before realizing they were searching for the wrong one
                //see if this can be a switch case or lists so all the good/bad ones can fall through to the right handlers
                self.isBusy(false);
                self.contacts(data);
            },
            error: function (error) {
                console.log("Call Failed");
                self.isBusy(false);
            }
        });
    }

    self.formatEmail = function (email) {
        return 'mailto:' + email;
    };

    self.formatTimezone = function (timeZoneDefaultCity) {
        return moment.tz(timeZoneDefaultCity).zoneAbbr();
    };

    self.init = function () {
        self.getContacts();
    }
};

$(document).ready(function () {
    var contactViewModel = new ContactViewModel();
    contactViewModel.init();
    ko.applyBindings(contactViewModel);
});